import { React, useState, useEffect, useRef } from "react";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function EditPDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Edit PDF file" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/pdf_editor", title: "PDF Editor, Creator Free" },
    data2: { link: "/pdf_editor", title: "PDF Editor Online" },
    data3: { link: "/pdf_editor", title: "Edit PDF File Online For Free" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Edit PDF online easily. Modify text, images, and pages, merge or split PDFs quickly with our fast, secure, and user-friendly PDF editor tool."
      ></meta>
      <meta
        name="keywords"
        content="PDF editor, edit PDF online, modify PDF, PDF text editor, online PDF editor, merge PDF, split PDF, PDF page editor, PDF editing tool, PDF management tool, secure PDF editor, edit PDF documents, online PDF tool, PDF file editor, PDF editor free"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <></>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={true} />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1615002918}`}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our PDF Editor Free website provides a powerful, secure, and easy-to-use solution to edit PDF documents both offline and online. Designed for students, professionals, and businesses, this versatile tool allows users to edit PDF files with ease—whether it’s modifying text, adding images, inserting annotations, filling forms, or updating document properties. With offline functionality, this offline PDF editor processes files directly on your device, ensuring complete privacy and data security without uploading documents to external servers. When internet access is available, users can seamlessly edit PDF online using a fast, browser-based interface for instant updates. As a reliable PDF editor online, the platform preserves original formatting, fonts, and layout while delivering high-quality edits. The website supports essential editing workflows and is ideal for resumes, contracts, reports, invoices, and academic documents. Using advanced editing technology, this online PDF editor allows users to make changes efficiently without complex software installation. Compatible with desktop and mobile devices, the tool enables you to edit PDF offline or online anytime, offering flexibility for every workflow. If you are searching for the best PDF editor free, edit PDF online, edit PDF offline, offline PDF editor, or a secure and fast online PDF editor, this website delivers a complete, user-friendly, and privacy-focused PDF editing experience." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Edit",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="PDF Editor"
            why_use={[
              {
                title: "Edit PDF Files Easily",
                description:
                  "A PDF editor allows you to edit PDF text, images, and content without recreating the document. Using a PDF editor online makes updates quick and simple.",
              },
              {
                title: "Save Time and Effort",
                description:
                  "Instead of converting files to other formats, a free PDF editor lets you edit PDF files directly and speeds up everyday document workflows.",
              },
              {
                title: "Edit PDF Online Anytime",
                description:
                  "With edit PDF online tools, you can make quick changes from any device using a reliable online PDF editor without installing software.",
              },
              {
                title: "Edit PDF Offline Securely",
                description:
                  "This offline PDF editor lets you edit PDF offline, ensuring privacy and uninterrupted work even without an internet connection.",
              },
              {
                title: "Ideal for Professional Documents",
                description:
                  "Resumes, contracts, invoices, and reports often need updates. Our powerful PDF editor free preserves formatting for professional results.",
              },
              {
                title: "Fill and Edit PDF Forms",
                description:
                  "Our PDF editor allows you to fill, edit, and save form fields easily, making it perfect for official and business document submissions.",
              },
              {
                title: "Improve Collaboration and Sharing",
                description:
                  "Using an online PDF editor, teams can review, comment, and share documents efficiently without compatibility issues.",
              },
              {
                title: "Boost Productivity and Efficiency",
                description:
                  "Whether online or offline, this PDF editor streamlines document management and reduces repetitive editing tasks.",
              },
              {
                title: "Flexible Online and Offline Access",
                description:
                  "This tool that works as both an online PDF editor and offline PDF editor gives complete flexibility to edit PDFs anytime and anywhere.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "How can I edit a PDF online for free?",
                description:
                  "Visit ShivaPDF.com and open the PDF Editor tool. Select a supported PDF file, make changes using the available editing features, and download the edited document to your device. No separate PDF editing software is required."
              },
              {
                title: "Can I edit PDF files without uploading them?",
                description:
                  "ShivaPDF is designed to process supported PDF files locally in your browser, allowing you to edit documents without uploading their contents to a remote server. Your files remain on your device during local processing."
              },
              {
                title: "Is ShivaPDF's PDF editor free to use?",
                description:
                  "ShivaPDF offers browser-based PDF tools that help you edit and manage PDF documents for free, subject to any usage limits displayed on the website."
              },
              {
                title: "Can I edit a PDF offline?",
                description:
                  "You may need an internet connection to open ShivaPDF.com initially. If the PDF Editor and all its required resources are available locally, you can edit supported PDF files without an active internet connection."
              },
              {
                title: "Are my PDF files private when using ShivaPDF?",
                description:
                  "ShivaPDF's local-processing workflow is designed to handle supported PDF files directly in your browser without uploading their contents to a remote server. This helps keep your documents on your device during editing."
              },
              {
                title: "Do I need to install software to edit a PDF?",
                description:
                  "No, ShivaPDF provides browser-based PDF editing tools that work without a separate desktop application. Open the tool in a compatible browser, select your document, and use the available editing features."
              },
              {
                title: "What can I edit in a PDF?",
                description:
                  "Available editing features depend on the tools supported by ShivaPDF. These may include adding text, inserting images, rotating pages, cropping pages, deleting pages, and rearranging document pages."
              },
              {
                title: "Can I add text to a PDF?",
                description:
                  "If text insertion is supported, you can add text to your PDF for notes, labels, annotations, or additional information. Position the text as needed and save the updated document."
              },
              {
                title: "Can I add images to a PDF?",
                description:
                  "If image insertion is available, you can place supported images into your PDF document. This is useful for adding logos, signatures, illustrations, or other visual elements."
              },
              {
                title: "Can I edit PDF files on my mobile phone?",
                description:
                  "Yes, you can access supported ShivaPDF editing tools through a compatible browser on an iPhone, Android phone, or tablet. Editing capabilities may vary depending on your device and browser."
              },
              {
                title: "Can I edit a scanned PDF?",
                description:
                  "You can perform supported page-level edits on scanned PDFs, such as rotating, cropping, or deleting pages. Editing the actual text inside a scanned document may require OCR or text recognition, if available."
              },
              {
                title: "Can I edit a PDF without creating an account?",
                description:
                  "You can use the PDF editing tools without creating an account if registration is not required by the website. Check the relevant tool page for any applicable restrictions."
              },
              {
                title: "Will editing a PDF change my original file?",
                description:
                  "Your original PDF can remain unchanged when you download the edited document as a separate file. Keep a backup of important documents before making changes."
              },
              {
                title: "Can I edit a password-protected PDF?",
                description:
                  "Some password-protected PDFs require authorization or unlocking before they can be edited. Only modify protected documents when you have permission to do so."
              },
              {
                title: "Will editing a PDF reduce its quality?",
                description:
                  "Basic page operations generally preserve the appearance of existing content. However, operations involving image replacement, conversion, compression, or text reconstruction may affect quality depending on the method used."
              },
              {
                title: "Does ShivaPDF store my PDF documents?",
                description:
                  "ShivaPDF's local-processing workflow is designed to process supported PDF documents in your browser without uploading their contents to a remote server. This helps keep your files on your device during processing."
              },
              {
                title: "Can I edit a PDF without an internet connection?",
                description:
                  "If the PDF Editor has already loaded and all required resources are available locally, supported editing operations can work without an active internet connection. Initial access to the website may require connectivity."
              },
              {
                title: "Can I combine or rearrange PDF pages?",
                description:
                  "If page management features are available, you can rearrange pages or combine PDF documents using the relevant ShivaPDF tools. Check the available options to confirm which operations are supported."
              },
              {
                title: "How do I download an edited PDF?",
                description:
                  "After making your changes, select the available download or save option to export the edited PDF to your device. Open the resulting file to check that the changes appear as expected."
              },
              {
                title: "Why should I use a local PDF editor?",
                description:
                  "A local PDF editor processes supported document contents on your device rather than uploading them to a remote server. It offers a convenient way to manage PDF files in your browser while helping protect document privacy."
              },
              {
                title: "Is a browser-based PDF editor secure?",
                description:
                  "Security depends on how the tool processes files and handles website data. Local PDF processing can reduce exposure of document contents by keeping them on your device. Always use a trusted website and review its privacy policy."
              }
            ]} />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default EditPDFMain;
